import { debugLog, Type } from '../utils';

export type PropertyToValue = (value: any) => any | null;
export type PropertyToValueDict = { [key: string]: PropertyToValue | null };
export type ObjectType = "S" | "O";

export type ChangeLog = {
    Type: ObjectType,
    Name?: string;
    Notes?: string;
    Changes: { [key: string]: { from?: any; to?: any; } };
};

export const changesToChangeLog = (changes: any, oldValues: any, propertyToValue: PropertyToValueDict, type: ObjectType, name?: string): ChangeLog | null => {
    const keys = Object.keys(changes);

    if (!keys.length)
        return null;

    let changeCounter = 0;
    const result: ChangeLog = {
        Type: type,
        Name: name,
        Notes: changes.AuditComment,
        Changes: {}
    };
    for (const key of keys) {
        let to = changes[key];
        if (to !== undefined && key !== 'AuditComment') {
            const propertyToStringProc = propertyToValue[key];
            let from = oldValues[key];
            if (propertyToStringProc) {
                if ((to = propertyToStringProc(to)) === undefined)
                    continue;
                if (!Type.isNullOrUndefined(from))
                    from = propertyToStringProc(from);
            }
            changeCounter++;
            if (Type.isNullOrUndefined(from))
                result.Changes[key] = { to };
            else
                result.Changes[key] = { from, to };
        }
    }
    //console.log("changesToChangeLog", JSON.stringify(result));
    return changeCounter || result.Notes ? result : null;
}

export function objectToJsonAuditComment(changes: any, oldValues: any, propertyToValue: PropertyToValueDict, type: ObjectType, name?: string): string | null {
    const log = changesToChangeLog(changes, oldValues, propertyToValue, type, name);
    return log ? JSON.stringify(log) : null;
}

